// src/pages/design/Fcr_view.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MobileFormViewManager from "../../components/common/mobile/MobileFormViewManager";
import MobileShareButton from "../../components/common/mobile/MobileShareButton";
import PeopleView from "../../components/common/people/PeopleView";
import TinyMCEpreview from "../../components/const/TinyMCEpreview";
import { getDocPersons } from "../../api/papers";
import { changeDocState } from "../../api/design/meta"; // ⭐ state 변경 API

export default function Fcr_view() {
  const { id: project, dns } = useParams();
  const navigate = useNavigate();

  const handleCreateFCN = () => {
    navigate(`/project/${project}/design/fcn/new?fromFCR=${dns}`);
  };

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner">
        <MobileFormViewManager
          params={{
            module: "design",
            doc_type: "FCR",
            project,
            dns,
          }}
          doc_name={"설계변경요청서"}
        >
          <FcrViewContent onCreateFCN={handleCreateFCN} dns={dns} />
        </MobileFormViewManager>
      </div>
    </div>
  );
}

function FcrViewContent({ meta, data, onCreateFCN, dns }) {
  const { id: project } = useParams();

  const me = JSON.parse(localStorage.getItem("user") || "null");
  const myUserId = me?.id || me?.user?.id;

  const [people, setPeople] = useState([]);

  // ⭐ 상태(state / status)를 하나로 정리
  const docState =
    data?.state ?? meta?.state ?? data?.status ?? meta?.status ?? null;

  useEffect(() => {
    const loadPeople = async () => {
      try {
        const list = await getDocPersons(dns);
        console.log("📌 [getDocPersons] 문서 담당자 목록 >>>", list);
        setPeople(list || []);
      } catch (error) {
        console.error("❌ 담당자 로드 오류:", error);
        setPeople([]);
      }
    };
    loadPeople();
  }, [dns]);

  // ▸ 담당자인지 여부
  const isAssignee = people.some(
    (p) => p.id === myUserId || p.userId === myUserId || p.user_id === myUserId
  );

  // ⭐ 버튼 노출 조건
  // save 상태에서만 담당자가 "FCN 생성" / "반려" 가능
  const canReject = isAssignee && docState === "save";
  const canCreateFCN = isAssignee && docState === "save";

  // 디버그 로그
  useEffect(() => {
    console.log("🧑‍💻 [User] 현재 로그인 사용자 >>>", me);
    console.log("👥 [People] >>>", people);
    console.log("🔍 isAssignee:", isAssignee);
    console.log("📄 docState:", docState);
    console.log("🟢 canCreateFCN:", canCreateFCN, "🔴 canReject:", canReject);
  }, [people, docState, isAssignee, canCreateFCN, canReject, me]);

  // ⭐ 상태 변경 처리 (반려)
  const handleReject = async () => {
    if (!window.confirm("요청을 반려하시겠습니까?")) return;
    try {
      await changeDocState(dns, "reject");
      alert("요청이 반려되었습니다.");
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert("반려 처리 중 오류가 발생했습니다.");
    }
  };

  const sectionStyle = "rounded-lg border bg-white p-3 min-w-0 w-full";
  const sectionStyleObj = { width: '100%', maxWidth: '100%', boxSizing: 'border-box' };

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner space-y-3">
        {/* 요청 정보 */}
        <section className={sectionStyle} style={sectionStyleObj}>
          <div className="text-sm font-semibold mb-4 text-gray-900">요청 정보</div>

          <div className="space-y-4 min-w-0 w-full">
            {/* 요청 담당자 */}
            <div className="flex flex-col gap-1.5 min-w-0 w-full border-b border-gray-100 pb-3">
              <div className="text-xs text-gray-600 font-medium">요청 담당자</div>
              <div className="text-sm text-gray-900 break-words leading-relaxed">
                <PeopleView dns={dns} placeholder="지정된 담당자 없음" />
              </div>
            </div>

            {/* 요청 사유 */}
            {meta?.reason && (
              <div className="flex flex-col gap-1.5 min-w-0 w-full">
                <div className="text-xs text-gray-600 font-medium">요청 사유</div>
                <div className="text-sm text-gray-900 break-words leading-relaxed min-w-0 w-full">
                  <TinyMCEpreview html={meta.reason} />
                </div>
              </div>
            )}
          </div>
        </section>

        {/* 변경 항목 내역 */}
        <section className={sectionStyle} style={sectionStyleObj}>
          <div className="text-sm font-semibold mb-4 text-gray-900">변경 항목 내역</div>
          <div className="space-y-3 min-w-0 w-full">
            {Array.isArray(meta?.details) && meta.details.length > 0 ? (
              meta.details.map((r, i) => (
                <div
                  key={i}
                  className="border border-gray-200 rounded-lg p-3 bg-gray-50 space-y-2 min-w-0 w-full"
                >
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-medium text-gray-600">No.</span>
                    <span className="text-sm font-semibold text-gray-900">{i + 1}</span>
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <div className="text-xs text-gray-600 font-medium">항목</div>
                    <div className="text-sm text-gray-900 break-words">
                      {r.item || r.drawingNo || "-"}
                    </div>
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <div className="text-xs text-gray-600 font-medium">변경 전 내용</div>
                    <div className="text-sm text-gray-900 break-words">
                      {r.before || r.original || "-"}
                    </div>
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <div className="text-xs text-gray-600 font-medium">변경 후 내용</div>
                    <div className="text-sm text-gray-900 break-words">
                      {r.after || r.changed || "-"}
                    </div>
                  </div>
                  {(r.note || r.cause) && (
                    <div className="flex flex-col gap-1.5">
                      <div className="text-xs text-gray-600 font-medium">비고</div>
                      <div className="text-sm text-gray-900 break-words">
                        {r.note || r.cause}
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="text-center text-sm text-gray-400 py-4">
                변경 항목 내역이 없습니다.
              </div>
            )}
          </div>
        </section>

        {/* 액션 버튼 영역 - 요청 정보와 첨부자료 사이 */}
        {(canCreateFCN || canReject) && (
          <section className={`${sectionStyle} no-print`} style={sectionStyleObj}>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full">
              {canCreateFCN && (
                <button
                  onClick={onCreateFCN}
                  className="btn-create text-sm px-4 py-2.5 flex-1 sm:flex-initial flex-shrink-0 whitespace-nowrap"
                >
                  FCN 생성
                </button>
              )}
              {canReject && (
                <button
                  onClick={handleReject}
                  className="btn-delete text-sm px-4 py-2.5 flex-1 sm:flex-initial flex-shrink-0 whitespace-nowrap"
                >
                  반려
                </button>
              )}
              <MobileShareButton
                title={`설계변경요청서 (FCR)`}
                className="flex-shrink-0"
              />
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
